export default "__VITE_ASSET__37db8278__"